import React, { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom/cjs/react-router-dom';

import useGetDevicesForCustomer from '../../hooks/useGetDevicesForCustomer';
import { useHttpGetGatewaysAmongDevices, useHttpGetGatewayDetailsForDevices } from '../../hooks';
import Loader from '../../components/Loader';
import GatewayCard from './GatewayCard';

const GatewaysPage = () => {
    const { id: customerId } = useParams();
    const { isReady: devicesReady, data: devices } = useGetDevicesForCustomer(customerId, true);

    const deviceIds = useMemo(() => (devicesReady ? devices.map(d => d.id) : []), [devicesReady, devices]);
    const { isReady: gatewaysReady, data: gatewayIds } = useHttpGetGatewaysAmongDevices(deviceIds);

    const gatewayDeviceIds = gatewayIds?.data?.device_ids ?? [];
    const gatewayDevices = devicesReady && gatewaysReady ? devices.filter(d => gatewayDeviceIds.includes(d.id)) : [];

    const { gateways, isReady: detailsReady } = useHttpGetGatewayDetailsForDevices(gatewayDevices);

    if (!devicesReady || !gatewaysReady || !detailsReady) {
        return <Loader />;
    }

    return (
        <div className="gateways-page">
            <div className="gateways-page__header">
                <Link className="gateways-page__back" to={`/devicesdetail/${customerId}`}>
                    &#60; Back to customer
                </Link>
                <div className="gateways-page__heading">
                    <h1 className="gateways-page__title">Gateways</h1>
                    <span className="gateways-page__subtitle">
                        {customerId} · {gateways.length} {gateways.length === 1 ? 'gateway' : 'gateways'}
                    </span>
                </div>
            </div>

            {gateways.length === 0 ? (
                <div className="gateways-page__empty">No gateways found for this customer.</div>
            ) : (
                <div className="gateways-page__grid">
                    {gateways.map(gateway => (
                        <Link
                            key={gateway.id}
                            className="gateways-page__card-link"
                            to={{
                                pathname: `/gateways/${gateway.id}`,
                                // Normalize the customer device shape to what the single page reads.
                                state: {
                                    gateway: {
                                        device_id: gateway.id,
                                        name: gateway.custom_device_name || gateway.name,
                                        reference: gateway.info?.reference,
                                        gateway_id: gateway.info?.gateway_id,
                                        retailer_customer_id: customerId,
                                    },
                                },
                            }}
                        >
                            <GatewayCard gateway={gateway} />
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
};

export default GatewaysPage;
